/**************************************************
 * Nombre:       Formulario_Doc_Requerido
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {Flag} from "@mui/icons-material";
import IngresoSelect from "../../../Modulo_formularios/Componentes/IngresoSelect";
import {PAISESINDICATIVO} from "../../../Modulo_formularios/Recursos/indicativos";
import {useIngresarObjeto} from "../../../Modulo_formularios/Hooks/useIngresarObjeto";
import Tarjeta_Documento_Requerido from "../../Tarjetas/Tarjeta_Documento_Requerido";
import Formulario_Documento_Requerido from "./Formulario_Documento_Requerido";

const Formulario_Doc_Requerido = ({...props}) => {
    const {IngresarObjeto} = useIngresarObjeto({
        props: props,
        nombre: 'Documento',
        dato: 'documentos',
        Tarjeta: Tarjeta_Documento_Requerido,
        Formulario: Formulario_Documento_Requerido
    })

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoSelect Icono={Flag} nombre={'Pais'} dato={'pais'} {...props}
                                   requerido={'El estado es requerido'}
                                   opciones={[...PAISESINDICATIVO.map((it) => it.nameES), 'Todos']}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', px: 0.5}}>
                    <Typography>Lista de Documentos Requeridos</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <IngresarObjeto/>
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Doc_Requerido